import React, { FC, useContext, useEffect, useMemo } from 'react';
import { useIsMobile } from '@sravni/react-utils';
import { useFormContext } from 'react-hook-form';
import { useLoggedIn } from '../../../../../store/reducers/user';
import { StepContext } from '../../../creator/step.context';
import { FORM_FIELDS, FORM_STEPS } from '../../../../../constants';
import { PURPOSE_SOURCE_VALUES } from '../../../../../constants/sources';
import { Rows, Col, Row } from '../../../../landing.common';
import { FocusFieldWrapper, StepContainer, StepSubmitBlock, StepSubtitle } from '../common';
import { useFormFields } from '../../../../../store/selectors/formStore';
import { SubmitView } from './components/submit.view';
import { AmountField, PurposeField, RegionField } from './fields';
import { ContactDesktopFields, AutoDesktopFields } from './components/desktop';

export const ParamsStepView: FC = React.memo(() => {
    const isMobile = useIsMobile();
    const loggedIn = useLoggedIn();
    const { currentStepConfig, setShowLanding } = useContext(StepContext);
    const [selectedPurpose] = useFormFields([FORM_FIELDS.PURPOSE]);

    const form = useFormContext();

    const {
        formState: { dirtyFields: _ },
        setFocus,
    } = form;

    useEffect(() => {
        if (currentStepConfig.stepName === FORM_STEPS.PARAMS) {
            if (!isMobile && !loggedIn) {
                try {
                    setFocus(FORM_FIELDS.PHONE);
                } catch (e) {
                    // nothing
                }
            }
        }
    }, []);

    useEffect(() => {
        if (setShowLanding) {
            setShowLanding(true);
        }
    }, [selectedPurpose, setShowLanding]);

    const isAutoCreditSelected = useMemo(
        () => [PURPOSE_SOURCE_VALUES.NEW_CAR, PURPOSE_SOURCE_VALUES.USED_CAR].includes(selectedPurpose),
        [selectedPurpose],
    );

    return (
        <StepContainer>
            <Row gap="16" mobileGap="12">
                <Col md-4>
                    <FocusFieldWrapper name={FORM_FIELDS.PURPOSE} field={<PurposeField />} />
                </Col>
                <Col md-4>
                    <FocusFieldWrapper name={FORM_FIELDS.AMOUNT} field={<AmountField />} />
                </Col>
                <Col md-4>
                    <FocusFieldWrapper name={FORM_FIELDS.REGION} field={<RegionField />} />
                </Col>
            </Row>
            {isAutoCreditSelected && <AutoDesktopFields />}
            <Rows gap="16">
                <StepSubtitle>Контактные данные</StepSubtitle>
                <ContactDesktopFields />
            </Rows>
            <StepSubmitBlock>
                <SubmitView />
            </StepSubmitBlock>
        </StepContainer>
    );
});

ParamsStepView.displayName = 'ParamsStepView';
